import { Box, Typography } from '@mui/material'
import CustomOption2 from '../components/CustomOption2'
import CustomCheckbox from '../components/Inputs/CustomCheckbox'
const Electrical = () => {
  return (
    <Box sx={{ padding: '20px 0px 40px 0px' }}>
      <Typography className="general-text-light" sx={{ mb: 6 }}>
        <span className="general-text">Task Name - </span>Electrical
      </Typography>
      <Typography className="general-text">Hazardous Elements</Typography>
      <CustomCheckbox
        label="Power Sources, Tools and Leads"
        name="Power_Sources_Tools_and_Leads"
        component={
          <Box>
            <CustomOption2
              label="Electric shock injury - "
              name="Electric_shock_injury"
              warning={true}
              sliderDescription="Identify all active power sources - remember that despite electricity has been turned off at the property does not turn of electricity on the street. Pre Start check to ensure all electrical plant and equipment is in good working order. If deemed non operational - must be taken out of use and report to management. Ensure all electrical tools have a valid electrical testing and tag label - if not tagged remove from service and report to management. Cover/mask electrical sockets/GPO's - ensure socket is safe during the works"
            />
          </Box>
        }
        conditional_heading="Power Sources, Tools and Leads"
      />
      <CustomCheckbox
        label="Aluminium / steel extension roller handles"
        name="Aluminium_steel_extension"
        component={
          <Box>
            <CustomOption2
              label="Electric shock injury -"
              name="Electric_shock_injury"
              warning={true}
              sliderDescription="Pre start check to identify electrical hazards, prior to use of aluminium/steel extension roller handles."
            />
          </Box>
        }
        conditional_heading="Aluminium / steel extension roller handles"
      />
      <CustomCheckbox
        label="Overhead Power Lines"
        name="Overhead_Power_Lines"
        component={
          <Box>
            <CustomOption2
              label="Electric shock injury - "
              name="overhead_Electric_shock_injury"
              warning={true}
              sliderDescription="Check for overhead wires, power lines and electrical installations prior to setting up work area to perform scope of works. Pre start check before setting up access equipment"
            />
          </Box>
        }
        conditional_heading="Overhead Power Lines"
      />
    </Box>
  )
}

export default Electrical
